module.exports = __webpack_public_path__ + "img/screen-1.94a23d38.svg";